import { NgModule } from '@angular/core';
declare const _paq: any;

@NgModule({
  declarations: [],
  imports: [],
  providers: []
})
export class Piwiktrack {
  static piwikTrackClickLink( url: string, token: string | null) {
    const find = '\'';
    const re = new RegExp(find, 'g');
    try {
      _paq.push(['trackLink', url.replace(re, '\''), 'link', {access: ModuleNameEnum.MobileView, token: token}]);
    } catch (e) {
      console.log(e);
    }

  }

  static piwikTrackPage(newsName:string | null,module: ModuleNameEnum, token: string | null) {
    try {
      _paq.push(['trackPageView', newsName, {access: module, token: token}]);
    } catch (e) {
      console.log(e);
    }

  }
}
export enum ModuleNameEnum {
  Sociabble = 'SOCIABBLE',
  SociabbleClick = 'SOCIABBLE_POST_CLICK',
  MobileView = "MOBILE",
  ScreenView = "SCREEN",
  ErrorView= "ERROR"
}
